import { lazy } from 'react';

// project import
import GuestGuard from 'guards/GuestGuard';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/auth/login')));
const AuthSetNewPassword = Loadable(lazy(() => import('pages/auth/set-new-password')));

// ==============================|| AUTH ROUTING ||============================== //

const AuthRoutes = {
  path: '/',
  element: (
    <GuestGuard>
      <CommonLayout />
    </GuestGuard>
  ),
  children: [
    {
      path: 'login',
      element: <AuthLogin />
    },
    {
      path: 'reset-password',
      element: <AuthSetNewPassword reset />
    },
    {
      path: 'set-new-password',
      element: <AuthSetNewPassword />
    }
  ]
};

export default AuthRoutes;
